'use client'

import { useCMSMenu } from '@/src/domains/cms-menus/hooks/useCMSMenu'
import { getHeaderSubmenu } from '@/src/domains/header/components/Header/Header.utils'
import { StrapiMenuSpecialFunction } from '@/src/domains/strapi/constants'

import { useHeaderServiceMenuItems } from './useHeaderServiceMenuItems'

export const useHeaderTherapistsSubmenus = () => {
  const { data } = useCMSMenu('therapist-menu')
  const serviceMenuItems = useHeaderServiceMenuItems()

  return data.map((menu) => {
    const submenu = getHeaderSubmenu(menu)

    return menu.special_function === StrapiMenuSpecialFunction.SERVICES
      ? { ...submenu, items: serviceMenuItems }
      : submenu
  })
}
